// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { environment as sharedEnv } from 'src/environments/environment';

// If you have any project specific customizations to the environment apply them here to the sharedEnv object

export const environment = sharedEnv;
